/* huurmeteen.nl — theme interactions.
   ---------------------------------------------------------------------------
   Framework-free, and written to survive the Shopify THEME EDITOR.

   The editor re-renders a single section over AJAX when you edit it. Anything
   bound directly to elements at page load is lost the moment that happens, and
   any element hidden by `.js .reveal { opacity: 0 }` stays invisible because the
   reveal pass already ran — which is why an edited section previously went blank.

   Two rules keep it robust:
     1. EVENT DELEGATION on `document`, so handlers never need re-binding.
     2. Re-run the reveal pass on Shopify's section lifecycle events, and in
        design mode show everything immediately (no scroll-gating at all).
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.documentElement.classList.add("js");

  /* =========================================================================
     Scroll reveal
     Re-queries the DOM every pass — never caches a list that a re-render
     would invalidate. In the theme editor everything is shown immediately so
     editing a section can never leave it invisible.
     ========================================================================= */
  function revealAll() {
    var els = document.querySelectorAll(".reveal:not(.is-in)");
    for (var i = 0; i < els.length; i++) els[i].classList.add("is-in");
  }

  function revealInView() {
    var trigger = window.innerHeight * 0.92;
    var els = document.querySelectorAll(".reveal:not(.is-in)");
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < trigger) els[i].classList.add("is-in");
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      revealInView();
    });
  }

  if (designMode || reduceMotion) {
    revealAll();
  } else {
    revealInView();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    window.addEventListener("load", revealInView);
  }

  /* =========================================================================
     Mobile drawer — delegated
     ========================================================================= */
  var lastFocus = null;

  function setDrawer(open) {
    var drawer = document.getElementById("drawer");
    if (!drawer) return;
    var openBtn = document.querySelector("[data-drawer-open]");

    drawer.setAttribute("data-open", open ? "true" : "false");
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    if (openBtn) openBtn.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";

    if (open) {
      lastFocus = document.activeElement;
      var first = drawer.querySelector("a, button");
      if (first) first.focus();
    } else if (lastFocus && document.contains(lastFocus)) {
      lastFocus.focus();
    }
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-drawer-open]")) { setDrawer(true); return; }
    if (e.target.closest("[data-drawer-close]")) { setDrawer(false); }
  });

  document.addEventListener("keydown", function (e) {
    var drawer = document.getElementById("drawer");
    if (e.key === "Escape" && drawer && drawer.getAttribute("data-open") === "true") setDrawer(false);
  });

  /* =========================================================================
     Image galleries — delegated
     Featured vehicle (#veh-main) and product page (#pg-main) share the pattern:
     a button carrying data-src swaps the main image.
     ========================================================================= */
  function swapMain(mainEl, btn, siblings) {
    var src = btn.getAttribute("data-src");
    if (!src || !mainEl) return;
    mainEl.src = src;
    var inner = btn.querySelector("img");
    if (inner && inner.alt) mainEl.alt = inner.alt;
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].setAttribute("aria-current", siblings[i] === btn ? "true" : "false");
    }
  }

  document.addEventListener("click", function (e) {
    var vThumb = e.target.closest(".vehicle__thumbs button");
    if (vThumb) {
      swapMain(document.getElementById("veh-main"), vThumb,
               vThumb.parentNode.querySelectorAll("button"));
      return;
    }

    var pThumb = e.target.closest(".gallery__thumbs .thumb");
    if (pThumb) {
      swapMain(document.getElementById("pg-main"), pThumb,
               document.querySelectorAll(".gallery__thumbs .thumb"));
      return;
    }

    var prev = e.target.closest("[data-pg-prev]");
    var next = e.target.closest("[data-pg-next]");
    if (prev || next) {
      var thumbs = [].slice.call(document.querySelectorAll(".gallery__thumbs .thumb"));
      if (!thumbs.length) return;
      var current = 0;
      thumbs.forEach(function (t, i) { if (t.getAttribute("aria-current") === "true") current = i; });
      var target = prev ? current - 1 : current + 1;
      if (target < 0) target = thumbs.length - 1;
      if (target >= thumbs.length) target = 0;
      swapMain(document.getElementById("pg-main"), thumbs[target], thumbs);
    }
  });

  /* =========================================================================
     Image strip — arrows + drag, delegated
     ========================================================================= */
  document.addEventListener("click", function (e) {
    var dir = e.target.closest("[data-strip-prev]") ? -1
            : e.target.closest("[data-strip-next]") ? 1 : 0;
    if (!dir) return;
    var strip = document.getElementById("imgstrip");
    if (!strip) return;
    var first = strip.querySelector("img");
    var w = first ? first.getBoundingClientRect().width + 16 : strip.clientWidth / 2;
    strip.scrollBy({ left: dir * w, behavior: reduceMotion ? "auto" : "smooth" });
  });

  (function stripDrag() {
    var dragging = false, startX = 0, startScroll = 0, moved = false, el = null;

    document.addEventListener("pointerdown", function (e) {
      var strip = e.target.closest("#imgstrip");
      if (!strip) return;
      el = strip; dragging = true; moved = false;
      startX = e.clientX; startScroll = strip.scrollLeft;
      strip.classList.add("is-dragging");
    });

    document.addEventListener("pointermove", function (e) {
      if (!dragging || !el) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    function end() {
      if (!dragging || !el) return;
      dragging = false;
      el.classList.remove("is-dragging");
      el = null;
    }
    document.addEventListener("pointerup", end);
    document.addEventListener("pointercancel", end);

    // Suppress the click that follows a drag
    document.addEventListener("click", function (e) {
      if (moved && e.target.closest("#imgstrip")) { e.preventDefault(); moved = false; }
    }, true);
  })();

  /* =========================================================================
     Booking-bar routing
     Booking completes on the product page (IzyRent picker → checkout), so the
     homepage bar routes to the chosen category: the select's option values are
     collection URLs and the CTA follows them. Date/time ride along as query
     params — harmless, and the contact form can still prefill from them.
     Delegated `change`, so a re-rendered section keeps working.
     ========================================================================= */
  function updateIntentLinks(root) {
    if (!root) return;
    var ctas = root.querySelectorAll("[data-booking-cta]");
    if (!ctas.length) return;

    var sel = root.querySelector('select[name="voertuig"]');
    var parts = [];
    ["datum", "tijd"].forEach(function (name) {
      var el = root.querySelector('[name="' + name + '"]');
      if (el && el.value) parts.push(name + "=" + encodeURIComponent(el.value));
    });

    for (var i = 0; i < ctas.length; i++) {
      var base = (sel && sel.value) || ctas[i].getAttribute("data-base") || ctas[i].getAttribute("href");
      if (!base) continue;
      var sep = base.indexOf("?") > -1 ? "&" : "?";
      ctas[i].setAttribute("href", parts.length ? base + sep + parts.join("&") : base);
    }
  }

  function refreshIntent() {
    var roots = document.querySelectorAll("[data-booking]");
    for (var i = 0; i < roots.length; i++) updateIntentLinks(roots[i]);
  }

  document.addEventListener("change", function (e) {
    var root = e.target.closest("[data-booking]");
    if (root) updateIntentLinks(root);
  });

  /* =========================================================================
     Date fields — default to today, and never allow a past date
     ========================================================================= */
  function initDates() {
    var today = new Date();
    var iso = today.getFullYear() + "-" +
      String(today.getMonth() + 1).padStart(2, "0") + "-" +
      String(today.getDate()).padStart(2, "0");

    // Booking-bar date only; the product page's dates belong to IzyRent's picker.
    var f = document.getElementById("bk-date");
    if (f && !f.value) { f.min = iso; f.value = iso; }
  }

  /* =========================================================================
     Contact form prefill from ?voertuig=&datum=&tijd=
     Liquid cannot read query params, so this runs client side.
     ========================================================================= */
  function prefillContactForm() {
    var form = document.querySelector("[data-inquiry-form]");
    if (!form || !window.URLSearchParams) return;

    var params = new URLSearchParams(window.location.search);
    var map = {
      voertuig: 'select[name="contact[Voertuig]"]',
      datum: 'input[name="contact[Gewenste datum]"]',
      tijd: 'input[name="contact[Gewenste tijd]"]'
    };

    Object.keys(map).forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      var el = form.querySelector(map[key]);
      if (!el || el.value) return;

      if (el.tagName === "SELECT") {
        // Only select an option that exists, so a stale link cannot leave the
        // select showing something it does not hold.
        var match = Array.prototype.filter.call(el.options, function (o) {
          return o.value.toLowerCase() === value.toLowerCase();
        })[0];
        if (match) {
          el.value = match.value;
        } else {
          var body = form.querySelector('textarea[name="contact[body]"]');
          if (body && !body.value) body.value = "Ik ben op zoek naar: " + value;
        }
      } else {
        el.value = value;
      }
    });
  }

  /* =========================================================================
     Init + Shopify theme editor lifecycle
     ========================================================================= */
  function init() {
    initDates();
    prefillContactForm();
    refreshIntent();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-run after the editor swaps a section in, and re-reveal so an edited
  // section is never left invisible.
  document.addEventListener("shopify:section:load", function () {
    revealAll();
    init();
  });
  document.addEventListener("shopify:section:select", revealAll);
  document.addEventListener("shopify:block:select", revealAll);
})();
